import MoreMenuVertical from "@/components/icons/more-menu-vertical"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

interface OptionsDropdownMenuProps {
  children: React.ReactNode;
}

export default function OptionsDropdownMenu({
  children,
}: OptionsDropdownMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" data-testid="item-options">
          <MoreMenuVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">{children}</DropdownMenuContent>
    </DropdownMenu>
  )
}
